<template>
  <div
    :aria-labelledby="id"
    class="border-b border-l-[3px] flex gap-3 items-center p-4"
    :class="variant"
    role="alert">
    <IconBase class="icon shrink-0">
      <Info v-if="variant === 'info'" />
      <Error v-if="variant === 'alert'" />
      <Error v-if="variant === 'warning'" />
      <CheckRounded v-if="variant === 'success'" />
    </IconBase>
    <div
      :id="id"
      class="grow">
      <slot />
    </div>
    <Button
      :aria-label="t('messaging.close')"
      class="pl-4"
      variant="none"
      @click="emit('close')">
      <IconBase class="cursor-pointer">
        <Times />
      </IconBase>
    </Button>
  </div>
</template>

<script setup lang="ts">
import type {NotificationVariant} from '@myparcel-frontend/notifications';
import type {ValueOf} from '@myparcel-frontend/types';
import {IconBase, CheckRounded, Error, Info, Times, Button} from '@myparcel-frontend/ui';
import {useId} from 'vue';
import {useI18n} from 'vue-i18n';

defineProps<{
  variant: ValueOf<typeof NotificationVariant>;
}>();

const emit = defineEmits(['close']);

const id = useId();
const {t} = useI18n();
</script>

<style lang="scss" scoped>
@reference "../../../assets/css/index.css";

.alert {
  @apply bg-red-50 border-b-red-200 border-red-600;

  .icon {
    @apply text-red-600;
  }
}

.info {
  @apply bg-blue-100 border-b-blue border-blue-600;

  .icon {
    @apply text-blue-600;
  }
}

.warning {
  @apply bg-yellow-50 border-b-yellow-200 border-yellow-600;

  .icon {
    @apply text-yellow-600;
  }
}

.success {
  @apply bg-green-50 border-b-green-200 border-green-600;

  .icon {
    @apply text-green-600;
  }
}
</style>
